import { useEffect, useRef } from 'react';
import { useDrawerScrollElement } from '~/features/productList/components/VirtualizedList';

// Returns the filter list to the top when its search text changes, so the user lands on the results.
export const useScrollToTopOnSearch = (
    searchValue: string,
    scrollElementOverride?: HTMLElement | null,
) => {
    const contextScrollElement = useDrawerScrollElement();
    const scrollElement =
        scrollElementOverride === undefined ? contextScrollElement : scrollElementOverride;
    const previousSearchValueRef = useRef(searchValue);

    useEffect(() => {
        if (previousSearchValueRef.current === searchValue) return;

        previousSearchValueRef.current = searchValue;
        scrollElement?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [searchValue, scrollElement]);
};
